<template>
  <div class="TagList inner_center">
    <a
      v-for="vo in list"
      :href=" PAGE_PATH.BASE_URL + PAGE_PATH.TUPIAN_LIST + '/' + vo.pinyin + '.html' "
      target="_blank"
    >
      {{ vo.keyword }}
    </a>

    <div class="pagination-box">
      <CtPaginationA
        v-if="totalPage > 1"
        class="CtPagination"
        :total-page="totalPage"
        :paper-count="5"
        :current-page="page"
        @pageClick="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import {getTagList} from "@/api/tags";
import {CtPagination} from "@/components/common/index.js"
import {PAGE_PATH} from '@/constant/PAGE_PATH'
import fnTag from "@/pages/tags/fnTag";
import {MATERIAL_LIST_PATH} from "@/constant/PATH";
import {fnRouter} from "@/fn";
import CtPaginationA from "~/components/common/ct-pagination/ct-pagination-a";

export default {
  name: "TagList",
  layout: "header-nav",
  components: {
    CtPaginationA,
    CtPagination
  },
  data() {
    return {
      list: [],
      page: 1,
      totalPage: 0,
      // lastId: 0,
      PAGE_PATH
    }
  },
  async asyncData({app, store}) {
    let params = fnTag.parseUrl(app)
    let [tagList] = await Promise.all([app.$api.getTagList(params)])
    let {list, page, pages, lastId} = tagList.data

    return {
      list,
      page,
      totalPage: pages,
    }
  },
  methods: {
    handleCurrentChange(page) {
      let path = PAGE_PATH.BASE_URL + PAGE_PATH.TAGE + `/${page}.html`;
      fnRouter.navigationTo(path, '_self');

    }
  }
}
</script>

<style lang="scss" scoped>
.TagList {
  display: flex;
  flex-wrap: wrap;
  padding-top: 20px;

  a {
    display: inline-block;
    width: 25%;
    font-size: 16px;
    color: #424866;
    line-height: 34px;
    cursor: pointer;

    &:hover {
      color: $color-primary;
    }
  }

  .pagination-box {
    margin: 0 auto;
  }
}
</style>
